import { Component, OnInit, Input } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';

import { TermsAndConditionsComponent } from '../shared/terms-and-conditions.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  @Input() mode: string = 'light';

  constructor (private dialog: MatDialog) { }

  ngOnInit() {
  }

  showTermsAndConditions() {
    let dialogRef = this.dialog.open(TermsAndConditionsComponent, {
      height: Math.min(window.innerHeight, 480)+"px",
      width: Math.min(window.innerWidth, 640)+"px"
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/layouts/footer.component.ts